import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi";
import useShowLoader from "../common/loading-widgets/useShowLoader";
import Page from "../common/page/Page";
import SignInForm from "./SignInForm";
import "./SignInPage.scss";

export default function SignInPage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading, "SignInPage");

  return (
    <Page className="SignInPage">
      <Page.Title
        text={t("authentication-ui:sign_in_title")}
        loading={tLoading}
      />
      <Page.Content>
        <div className={"SignInPage"}>
          <Row>
            <Col>
              <SignInBlock />
            </Col>
          </Row>
        </div>
      </Page.Content>
    </Page>
  );
}

function SignInBlock() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading);

  return (
    <div className="SignInBlock">
      <Row>
        <Col>
          <h1>{t("authentication-ui:sign_in_title")}</h1>
        </Col>
      </Row>
      <Row>
        <Col className="sign-in-form-col">
          <div className="sign-in-form-div">
            <SignInForm />
          </div>
        </Col>
      </Row>
    </div>
  );
}
